import React from 'react';
import { Mail } from 'lucide-react';
import { SUPPORT_CONTACT_EMAIL } from './support.data';

const ContactSupport: React.FC = () => {
  return (
    <section className="support-contact" aria-labelledby="support-contact-heading">
      <h2 id="support-contact-heading" className="support-contact-title">
        Still need help?
      </h2>
      <p className="support-contact-copy">
        Can&apos;t find what you&apos;re looking for? Our team is happy to help.
      </p>
      <a
        className="support-contact-button"
        href={`mailto:${SUPPORT_CONTACT_EMAIL}`}
      >
        <Mail size={16} strokeWidth={2.2} aria-hidden="true" />
        Contact Support
      </a>
    </section>
  );
};

export default ContactSupport;
